import {cs}         from "./chain-services";
import {KeyLoader2} from "./key-loader-2";

export const CachedLoader = ({_key, fetch=undefined, load=undefined, disabled=false, next}) => cs(
    ["loader", (_, next) => KeyLoader2({
        disabled,
        keys: [_key],
        load: load ?? fetch,
        next,
    })],
    ({loader}) => next(
        loader.isLoading(_key) ? {
            loading: true,
        } : {
            value: loader.getValue(_key),
        }
    ),
);
